import type { ScheduleOption } from '../graphqlEnums'
import type { ShareMode } from '../save/graphqlTypes'

export const getShareMode = (option: ScheduleOption): ShareMode => {
  switch (option) {
    case 'Queue':
      return 'addToQueue'
    case 'Prioritize':
      return 'shareNext'
    case 'Now':
      return 'shareNow'
    case 'FixedTime':
      return 'customScheduled'
    default:
      throw new Error(`Unexpected schedule option: ${option}`)
  }
}
